export default __webpack_public_path__ + "bdbd099a8d2ef9593481ec8369f88ab4.png";